type Neighbor = { id: string } | null | undefined

// A state change on the open thread waits for the route to move before it
// dispatches. A neighbor that cannot move the route (the open thread itself,
// or a path without its id) would leave that dispatch queued forever.
export function pickMoveOnTarget({
	threadId,
	pathname,
	nextThread,
	prevThread,
}: {
	threadId: string
	pathname: string
	nextThread: Neighbor
	prevThread: Neighbor
}): "next" | "prev" | "exit" {
	const movesRoute = (target: Neighbor) =>
		!!target && target.id !== threadId && pathname.includes(threadId)
	if (movesRoute(nextThread)) return "next"
	if (movesRoute(prevThread)) return "prev"
	return "exit"
}
